export const vinStoryReportMockData = {
  // Dane podstawowe pojazdu
  vehicle: {
    carImageUrl:
      'https://cdn.builder.io/api/v1/image/assets/TEMP/a30cc01f7e73dae15fad4246b201dcd3c9cd86e9?placeholderIfAbsent=true&quot;',
    brand: 'BMW',
    model: 'Seria 3',
    fullModel: 'Seria 3 Diesel F30 16-',
    version: '320d xDrive (A8)',
    productionYear: '2017',
    modelYear: '2014',
    vin: 'WBA8C91090KXXXXXX',
    mileage: '118,635',
    countryOfOrigin: 'Niemcy',
    fuelType: 'diesel',
    engineDisplacement: '1995',
    enginePower: '190 KM / 140 kW',
    driveType: '4x4',
    engineLayout: 'Poprzeczny',
    transmission: 'automatyczna',
    bodyType: 'sedan',
    doorCount: '4',
    seatCount: '5',
    color: 'Niebieski metalik',
    maxWeight: '2,090 kg',
    gearCount: '8',
    logoUrl: '',
  },

  // Informacje o raporcie
  report: {
    orderNumber: 'VIN-50004',
    packageType: 'Premium',
    reportDate: '28.01.2025, 23:34',
    pagesCount: 85,
    sections: {
      specifications: { count: 94, label: 'informacje' },
      photos: { count: 0, label: 'Brak zdjęć' },
      timeline: { count: 20, label: 'zdarzeń' },
      damages: { count: 5, label: 'uszkodzeń' },
      mileageHistory: { count: '118635 km', label: 'przebieg' },
      valuation: { count: '82742 PLN', label: 'wycena' },
      equipment: { count: 84, label: 'dodatki' },
      warnings: { count: 2, label: 'ostrzeżenia' },
    },
  },

  // Ostrzeżenia
  warnings: [
    {
      id: '1',
      type: 'odometer_rollback',
      title: 'Możliwy cofnięty licznik',
      description:
        'Z zapisów przebiegu wynika że dnia 13-04-2023 stan licznika był niższy niż na poprzednim odczycie. Może to być spowodowane błędnym zapisem lub jest możliwe intencjonalne cofnięcie przebiegu.',
      icon: 'warning',
    },
    {
      id: '2',
      type: 'accident',
      title: 'Po uczestniczeniu w wypadku',
      description:
        'Jak wynika z zapisu badań technicznych, dnia 13-04-2023, zostało przeprowadzone badanie techniczne z opisem: Po uczestniczeniu w wypadku',
      icon: 'warning',
    },
  ],

  // Historia czasowa pojazdu
  timeline: [
    {
      id: '1',
      date: '2017-01-01',
      type: 'production',
      title: 'Został wyprodukowany',
      description:
        'Kraj (lub stan) wskazuje lokalizację zakładu produkcyjnego, zakładu montażowego lub adres rejestracyjny producenta. Data może być przybliżona.',
      country: 'Niemcy',
      details: {},
    },
    {
      id: '2',
      date: '21.03.2017',
      type: 'first_owner',
      title: 'Pierwszy właściciel',
      description: 'firma lub organizacja',
      country: 'Polska',
      voivodeship: 'dolnośląskie',
      details: { ownerType: 'company' },
    },
    {
      id: '3',
      date: '31.03.2017',
      type: 'first_registration',
      title: 'Pierwsza rejestracja w Polsce',
      country: 'Polska',
      details: {},
    },
    {
      id: '4',
      date: '25.07.2017',
      type: 'damage',
      title: 'Uszkodzenie pojazdu',
      description: 'Elementy karoserii zewnętrznej, Oświetlenie zewnętrzne',
      country: 'Polska',
      details: {
        estimatedValue: '2 000 - 2 500 PLN',
        damagedParts: [
          'Elementy karoserii zewnętrznej',
          'Oświetlenie zewnętrzne',
        ],
        mileage: 15432,
      },
    },
    {
      id: '5',
      date: '20.03.2018',
      type: 'owner_change',
      title: 'Zmiana właściciela',
      description: 'firma lub organizacja',
      country: 'Polska',
      voivodeship: 'dolnośląskie',
      details: { ownerType: 'company' },
    },
    {
      id: '6',
      date: '05.12.2018',
      type: 'damage',
      title: 'Uszkodzenie pojazdu',
      description:
        'Elementy karoserii zewnętrznej, Elementy konstrukcyjne nadwozia, Oświetlenie zewnętrzne, Układ chłodzenia i klimatyzacji',
      country: 'Polska',
      details: {
        estimatedValue: '18 000 - 19 000 PLN',
        damagedParts: [
          'Elementy karoserii zewnętrznej',
          'Elementy konstrukcyjne nadwozia',
          'Oświetlenie zewnętrzne',
          'Układ chłodzenia i klimatyzacji',
        ],
        mileage: 57543,
      },
    },
    {
      id: '7',
      date: '21.04.2020',
      type: 'damage',
      title: 'Uszkodzenie pojazdu',
      description: 'Elementy karoserii zewnętrznej, Oświetlenie zewnętrzne',
      country: 'Polska',
      details: {
        estimatedValue: '12 000 - 13 000 PLN',
        damagedParts: [
          'Elementy karoserii zewnętrznej',
          'Oświetlenie zewnętrzne',
        ],
        mileage: null,
      },
    },
    {
      id: '8',
      date: '06.05.2020',
      type: 'technical_inspection',
      title: 'Okresowe badanie techniczne',
      country: 'Polska',
      details: {
        inspectionNumber: 'DW/029/P',
        inspectionResult: 'positive',
        mileage: 79336,
      },
    },
    {
      id: '9',
      date: '22.02.2022',
      type: 'sale_purchase',
      title: 'Zbycie oraz nabycie pojazdu',
      country: 'Polska',
      details: {},
    },
    {
      id: '10',
      date: '22.02.2022',
      type: 'owner_change',
      title: 'Zmiana właściciela',
      description: 'osoba fizyczna',
      country: 'Polska',
      voivodeship: 'dolnośląskie',
      details: { ownerType: 'individual' },
    },
    {
      id: '11',
      date: '12.03.2022',
      type: 'total_loss',
      title: 'Szkoda całkowita',
      description:
        'Ubezpieczyciel: WARTA. Uszkodzenie elementów układu kierowniczego, Uszkodzenie elementów układu nośnego',
      country: 'Polska',
      details: {
        insurer: 'WARTA',
        damagedParts: [
          'Układy bezpieczeństwa biernego',
          'Układ zawieszenia',
          'Elementy karoserii zewnętrznej',
          'Elementy konstrukcyjne nadwozia',
          'Oświetlenie zewnętrzne',
          'Szyby',
          'Układ chłodzenia i klimatyzacji',
          'Tapicerka',
          'Układ kierowniczy',
        ],
        specificDamage: [
          'Uszkodzenie elementów układu kierowniczego',
          'Uszkodzenie elementów układu nośnego',
        ],
        mileage: 154654,
      },
    },
    {
      id: '12',
      date: '14.02.2023',
      type: 'significant_damage',
      title: 'Szkoda istotna',
      description:
        'Ubezpieczyciel: WARTA. Uszkodzenie elementów układu nośnego',
      country: 'Polska',
      details: {
        insurer: 'WARTA',
        estimatedValue: '28 000 - 29 000 PLN',
        damagedParts: [
          'Układy bezpieczeństwa biernego',
          'Układ zawieszenia',
          'Szyby',
          'Tapicerka',
          'Osprzęt silnika',
          'Układ kierowniczy',
        ],
        specificDamage: ['Uszkodzenie elementów układu nośnego'],
        mileage: 101356,
      },
    },
    {
      id: '13',
      date: '13.04.2023',
      type: 'technical_inspection',
      title: 'Dodatkowe badanie techniczne - cofnięty licznik',
      description: 'Po uczestniczeniu w wypadku',
      country: 'Polska',
      warnings: ['odometer_rollback', 'after_accident'],
      details: {
        inspectionNumber: 'OP/003/P',
        inspectionType: 'Po uczestniczeniu w wypadku',
        inspectionResult: 'positive',
        mileage: 101378,
      },
    },
    {
      id: '14',
      date: '11.09.2023',
      type: 'technical_inspection',
      title: 'Okresowe badanie techniczne',
      country: 'Polska',
      details: {
        inspectionNumber: 'PK/003/P',
        inspectionResult: 'positive',
        mileage: 118635,
      },
    },
  ],

  // Szczegółowe parametry pojazdu
  detailedSpecs: [
    { id: '1', label: 'Marka', value: 'BMW' },
    { id: '2', label: 'Model', value: 'Seria 3' },
    { id: '3', label: 'Rok produkcji', value: '2017' },
    { id: '4', label: 'Pojemność silnika', value: '1995 ccm' },
    { id: '5', label: 'Model (pełny)', value: 'Seria 3 Diesel F30 16-' },
    { id: '6', label: 'Wersja', value: '320d xDrive (A8)' },
    { id: '7', label: 'Rok modelowy', value: '2014' },
    { id: '8', label: 'Liczba drzwi', value: '4' },
    { id: '9', label: 'Rodzaj nadwozia', value: 'sedan' },
    { id: '10', label: 'Liczba miejsc', value: '5' },
    { id: '11', label: 'Moc silnika', value: '190 KM / 140 kW' },
    { id: '12', label: 'Liczba biegów', value: '8' },
    { id: '13', label: 'Rodzaj paliwa', value: 'diesel' },
    { id: '14', label: 'Napęd', value: '4x4' },
    { id: '15', label: 'Skrzynia biegów', value: 'automatyczna' },
    { id: '16', label: 'Przyspieszenie 0-100 km/h', value: '7.4 sek.' },
    { id: '17', label: 'Prędkość maksymalna', value: '233 km/h' },
    {
      id: '18',
      label: 'Zużycie paliwa w cyklu mieszanym',
      value: '4.3 l/100 km',
    },
    { id: '19', label: 'Pojemność zbiornika paliwa', value: '57 l' },
    { id: '20', label: 'Emisja CO₂', value: '112 g/km' },
    { id: '21', label: 'Standard emisji spalin', value: 'Euro 6' },
    { id: '22', label: 'Długość', value: '4633 mm' },
    { id: '23', label: 'Szerokość', value: '1811 mm' },
    { id: '24', label: 'Wysokość', value: '1416 mm' },
    { id: '25', label: 'Rozstaw osi', value: '2810 mm' },
    { id: '26', label: 'Pojemność bagażnika', value: '480 l' },
    { id: '27', label: 'Masa własna pojazdu', value: '1590 kg' },
    { id: '28', label: 'DMC - dopuszczalna masa całkowita', value: '2090 kg' },
    { id: '29', label: 'Kraj zakładu produkcyjnego', value: 'Niemcy' },
  ],

  // Historia szkód
  damageHistory: [
    {
      id: '1',
      date: '25.07.2017',
      estimatedValue: '2 000 - 2 500 PLN',
      damagedParts: [
        'Elementy karoserii zewnętrznej',
        'Oświetlenie zewnętrzne',
      ],
      mileage: 15432,
    },
    {
      id: '2',
      date: '05.12.2018',
      estimatedValue: '18 000 - 19 000 PLN',
      damagedParts: [
        'Elementy karoserii zewnętrznej',
        'Elementy konstrukcyjne nadwozia',
        'Oświetlenie zewnętrzne',
        'Układ chłodzenia i klimatyzacji',
      ],
      mileage: 57543,
    },
    {
      id: '3',
      date: '21.04.2020',
      estimatedValue: '12 000 - 13 000 PLN',
      damagedParts: [
        'Elementy karoserii zewnętrznej',
        'Oświetlenie zewnętrzne',
      ],
      mileage: null,
    },
    {
      id: '4',
      date: '12.03.2022',
      type: 'total_loss',
      insurer: 'WARTA',
      damagedParts: [
        'Układy bezpieczeństwa biernego',
        'Układ zawieszenia',
        'Elementy karoserii zewnętrznej',
        'Elementy konstrukcyjne nadwozia',
        'Oświetlenie zewnętrzne',
        'Szyby',
        'Układ chłodzenia i klimatyzacji',
        'Tapicerka',
        'Układ kierowniczy',
      ],
      specificDamage: [
        'Uszkodzenie elementów układu kierowniczego',
        'Uszkodzenie elementów układu nośnego',
      ],
      mileage: 154654,
    },
    {
      id: '5',
      date: '14.02.2023',
      type: 'significant_damage',
      insurer: 'WARTA',
      estimatedValue: '28 000 - 29 000 PLN',
      damagedParts: [
        'Układy bezpieczeństwa biernego',
        'Układ zawieszenia',
        'Szyby',
        'Tapicerka',
        'Osprzęt silnika',
        'Układ kierowniczy',
      ],
      specificDamage: ['Uszkodzenie elementów układu nośnego'],
      mileage: 101356,
    },
  ],

  // Historia przebiegu
  mileageHistory: [
    { date: '25.07.2017', mileage: 15432, source: 'Uszkodzenie pojazdu' },
    { date: '05.12.2018', mileage: 57543, source: 'Uszkodzenie pojazdu' },
    { date: '06.05.2020', mileage: 79336, source: 'Badanie techniczne' },
    { date: '12.03.2022', mileage: 154654, source: 'Szkoda całkowita' },
    { date: '13.09.2022', mileage: 169495, source: 'Badanie techniczne' },
    {
      date: '14.02.2023',
      mileage: 101356,
      source: 'Szkoda istotna',
      warning: true,
    },
    {
      date: '13.04.2023',
      mileage: 101378,
      source: 'Badanie techniczne',
      warning: true,
    },
    { date: '11.09.2023', mileage: 118635, source: 'Badanie techniczne' },
  ],

  // Wycena pojazdu
  valuation: {
    estimatedValue: 82742,
    currency: 'PLN',
    date: '28.01.2025',
    marketAnalysis: {
      similarVehicles: 25,
      priceRange: {
        min: 75000,
        max: 95000,
      },
    },
  },

  // Wyposażenie pojazdu
  equipment: {
    standardEquipment: [
      { id: 'B01', code: 'B01', name: 'ABS', category: 'standard' },
      {
        id: 'K64',
        code: 'K64',
        name: 'Audio - odtwarzacz mp3',
        category: 'standard',
      },
      {
        id: 'K59',
        code: 'K59',
        name: 'Audio - Radio z RDS',
        category: 'standard',
      },
      {
        id: 'K69',
        code: 'K69',
        name: 'Audio - wejścia USB',
        category: 'standard',
      },
      {
        id: 'K66',
        code: 'K66',
        name: 'Audio - złącze JACK',
        category: 'standard',
      },
      {
        id: 'B21',
        code: 'B21',
        name: 'Bezpieczeństwo - Immobilizer',
        category: 'standard',
      },
      { id: 'K73', code: 'K73', name: 'Czujnik deszczu', category: 'standard' },
      { id: 'K74', code: 'K74', name: 'Czujnik światła', category: 'standard' },
      {
        id: 'N02',
        code: 'N02',
        name: 'Filtr cząstek stałych',
        category: 'standard',
      },
      {
        id: 'K14',
        code: 'K14',
        name: 'Kierownica skórzana',
        category: 'standard',
      },
      {
        id: 'K2D',
        code: 'K2D',
        name: 'Kierownica wielofunkcyjna',
        category: 'standard',
      },
      {
        id: 'K11',
        code: 'K11',
        name: 'Klimatyzacja automatyczna',
        category: 'standard',
      },
      {
        id: 'K52',
        code: 'K52',
        name: 'Komputer pokładowy',
        category: 'standard',
      },
      {
        id: 'B42',
        code: 'B42',
        name: 'Kontrola trakcji',
        category: 'standard',
      },
      {
        id: 'B14',
        code: 'B14',
        name: 'Kurtyna powietrzna przednia',
        category: 'standard',
      },
      {
        id: 'B15',
        code: 'B15',
        name: 'Kurtyna powietrzna tylna',
        category: 'standard',
      },
      {
        id: 'K82',
        code: 'K82',
        name: 'Lusterko zewnętrzne reg. elektrycznie + podgrzewane',
        category: 'standard',
      },
      {
        id: 'B23',
        code: 'B23',
        name: 'Mocowania ISOFIX',
        category: 'standard',
      },
      { id: 'J80', code: 'J80', name: 'Napęd stały 4x4', category: 'standard' },
      {
        id: 'K85',
        code: 'K85',
        name: 'Opony - wskaźnik ciśnienia',
        category: 'standard',
      },
      {
        id: 'K1E',
        code: 'K1E',
        name: 'Opony - zestaw dojazowy',
        category: 'standard',
      },
      {
        id: 'B4B',
        code: 'B4B',
        name: 'Pasy bezpieczeństwa przednie',
        category: 'standard',
      },
      {
        id: 'B5B',
        code: 'B5B',
        name: 'Pasy bezpieczeństwa tylne',
        category: 'standard',
      },
      {
        id: 'B10',
        code: 'B10',
        name: 'Poduszka powietrzna kierowcy',
        category: 'standard',
      },
      {
        id: 'B11',
        code: 'B11',
        name: 'Poduszka powietrzna pasażera',
        category: 'standard',
      },
      {
        id: 'B63',
        code: 'B63',
        name: 'Poduszka powietrzna pasażera - dezaktywowana',
        category: 'standard',
      },
      {
        id: 'O03',
        code: 'O03',
        name: 'Przedni podłokietnik',
        category: 'standard',
      },
      {
        id: 'B67',
        code: 'B67',
        name: 'Reflektory halogenowe',
        category: 'standard',
      },
      {
        id: 'B70',
        code: 'B70',
        name: 'Reflektory p.mgłowe',
        category: 'standard',
      },
      {
        id: 'K8C',
        code: 'K8C',
        name: 'Regulacja wzdłużna kierownicy',
        category: 'standard',
      },
      {
        id: 'K7C',
        code: 'K7C',
        name: 'Regulowana wysokość kierownicy',
        category: 'standard',
      },
      { id: 'K39', code: 'K39', name: 'Relingi dachowe', category: 'standard' },
      {
        id: 'O97',
        code: 'O97',
        name: 'Silnik - uruchomienie przyciskiem',
        category: 'standard',
      },
      {
        id: 'O68',
        code: 'O68',
        name: 'Skrzynia biegów automatyczna 8 stopniowa',
        category: 'standard',
      },
      {
        id: 'B7A',
        code: 'B7A',
        name: 'Spryskiwacze szyby przedniej podgrzewane',
        category: 'standard',
      },
      {
        id: 'B12',
        code: 'B12',
        name: 'Strona poduszki powietrznej - przód',
        category: 'standard',
      },
      { id: 'B04', code: 'B04', name: 'System ASR', category: 'standard' },
      { id: 'B08', code: 'B08', name: 'System BAS', category: 'standard' },
      {
        id: 'B02',
        code: 'B02',
        name: 'System EDL - el. blokada dyferencjału',
        category: 'standard',
      },
      {
        id: 'B1S',
        code: 'B1S',
        name: 'System - połączenie alarmowe',
        category: 'standard',
      },
    ],

    equipmentPackages: [
      {
        id: 'connected-drive',
        name: 'ConnectedDrive Advanced',
        price: '6 990,24 PLN',
        items: [
          { code: 'K54', name: 'System nawigacyjny' },
          { code: 'K1C', name: 'System informacyjny online' },
          {
            code: 'K3C',
            name: 'Telefon - przygotowanie do telefonu z Bluetooth',
          },
          { code: 'K2V', name: 'Wyświetl wielofunkcyjny' },
        ],
      },
      {
        id: 'high-gloss-shadow',
        name: 'Individual High-gloss Shadow',
        price: '1 986,99 PLN',
        items: [{ code: 'K5K', name: 'Listwy boczne' }],
      },
      {
        id: 'comfort-access',
        name: 'System komfortowego dostępu',
        price: '2 254,47 PLN',
        items: [
          { code: 'K4B', name: 'Centralny zamek na kartę' },
          { code: 'K4G', name: 'Bagażnik - elektronicznie zamykany' },
          { code: 'K5G', name: 'Bagażnik - elektronicznie otwierany' },
        ],
      },
    ],

    additionalEquipment: [
      {
        id: 'B20',
        code: 'B20',
        name: 'Alarm bezpieczeństwa',
        price: '1 834,15 PLN',
      },
      {
        id: 'B10',
        code: 'B10',
        name: 'Automatyczne sterowanie światłami drogowymi',
        price: '498,37 PLN',
      },
      {
        id: 'B1T',
        code: 'B1T',
        name: 'Czujniki parkowania z przodu i z tyłu',
        price: '2 637,40 PLN',
      },
      {
        id: 'K26',
        code: 'K26',
        name: 'Deska rozdzielcza wykończenie aluminium',
        price: '1 108,94 PLN',
      },
      { id: 'L10', code: 'L10', name: 'Lakier metalic', price: '3 400,00 PLN' },
      {
        id: 'B17',
        code: 'B17',
        name: 'Lusterko wewnętrzne automatycznie przyciemniane',
        price: '688,62 PLN',
      },
      {
        id: 'K43',
        code: 'K43',
        name: 'Ogrzewane siedzenia przednie',
        price: '1 413,82 PLN',
      },
      {
        id: 'B1L',
        code: 'B1L',
        name: 'Reflektory przednie LED',
        price: '4 813,82 PLN',
      },
      {
        id: 'K45',
        code: 'K45',
        name: 'Siedzenia sportowe',
        price: '2 101,63 PLN',
      },
      {
        id: 'O27',
        code: 'O27',
        name: 'Siedzenie kierowcy z regulacją lędźwiową',
        price: '535,77 PLN',
      },
      {
        id: 'O34',
        code: 'O34',
        name: 'Siedzenie pasażera z regulacją lędźwiową',
        price: '535,77 PLN',
      },
      {
        id: 'K05',
        code: 'K05',
        name: 'System audio - HiFi',
        price: '1 491,87 PLN',
      },
      {
        id: 'B39',
        code: 'B39',
        name: 'System kamer parkowania',
        price: '1 603,25 PLN',
      },
      {
        id: 'K1B',
        code: 'K1B',
        name: 'Szyby przyciemniane',
        price: '1 491,87 PLN',
      },
      {
        id: 'J15',
        code: 'J15',
        name: 'Tarcze kół ze stopów lekkich 18',
        price: '5 922,76 PLN',
      },
      { id: 'J40', code: 'J40', name: 'Tempomat', price: '1 182,93 PLN' },
      {
        id: 'B51',
        code: 'B51',
        name: 'Tylne czujniki parkowania',
        price: '1 871,54 PLN',
      },
    ],

    totalAdditionalCost: 33132.51,
  },
};
